import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as bannerServices from "../../../services/banner.services";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const BannerEdit = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const [saveType, setSaveType] = useState("");
    const { t } = useTranslation()
    const [previewimage, setPreviewImage] = useState("");

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Banner"), url: "/admin/cms/banner/list/1" },
        { title: t("admin.faq.link_edit"), url: "" },
    ];

    useEffect(() => {
        bannerServices
            .Details(params.id)
            .then((data) => {
                setShowDefault(data && data?.data ? data.data : []);
                setPreviewImage(data.data.image);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (<Formik
                enableReinitialize
                initialValues={{
                    title: showdefault && showdefault.title ? showdefault.title : "",
                    description: showdefault && showdefault.description ? showdefault.description : "",
                    image: showdefault && showdefault.image ? showdefault.image : "",
                }}
                validate={(values) => {
                    const error = {};
                    const MAX_IMAGE_SIZE_MB = 5;
                    const allowedImageTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    if (!values.image) {
                        error.image = "Please upload an image.";
                    } else if (typeof values.image !== "string") {
                        if (!allowedImageTypes.includes(values.image.type)) {
                            error.image = "Invalid image format. Only JPEG, PNG, WEBP, or GIF allowed.";
                        }
                        const fileSizeMB = values.image.size / (1024 * 1024);
                        if (fileSizeMB > MAX_IMAGE_SIZE_MB) {
                            error.image = `Image size should not exceed ${MAX_IMAGE_SIZE_MB}MB.`;
                        }
                    }
                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    globalLoader(true);
                    let formData = new FormData();
                    formData.append("o_id", params.id);
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    if(values.image){
                        formData.append("image", values.image);
                    }
                    bannerServices
                        .Edit(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                if (saveType !== "Save") {
                                    setTimeout(() => {
                                        resetForm({ values: "" });
                                        globalLoader(false);
                                        navigate(`/admin/cms/banner/list/1`);
                                    }, 1000);
                                }
                                if (saveType === "Save") {
                                    setTimeout(() => {
                                        globalLoader(false);
                                    }, 1000);
                                }
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Edit Banner")}</h6>
                                        </div>
                                        {showdefault && Object.keys(showdefault).length > 0 ? (
                                            <div className="row row-sm">

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="title" className="text-left d-flex">
                                                        {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="title"
                                                        id="title"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}
                                                        className="form-control"
                                                        placeholder={t("admin.faq.faq_title_placeholder")}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.title && touched.title && t(errors.title)}
                                                    </span>
                                                </div>

                                                <div className="col-lg-12 text-center form-group">
                                                    <label htmlFor="description" className="text-left d-flex">
                                                        {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <CustomCkeditor
                                                        fieldname={"description"}
                                                        setFieldValue={setFieldValue}
                                                        value={values.description}
                                                        setFieldTouched={setFieldTouched}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.description &&
                                                            touched.description &&
                                                            t(errors.description)}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="image" className="text-left d-flex">
                                                        Upload Image:
                                                        {" "}
                                                        <small className="text-muted d-block mt-1 ms-2">
                                                        Please upload an image in{" "}
                                                        {/* <strong>
                                                            {1}:{1} ratio
                                                        </strong> */}
                                                        ({" "}
                                                        <code>
                                                            {2288}px width × {934}px height
                                                        </code>
                                                        ).
                                                    </small>
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="image"
                                                        name="image"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                           setFieldValue(
                                                                "image",
                                                                event.target.files[0] || ""
                                                            );
                                                            event.target.files.length === 1
                                                                ? setPreviewImage(
                                                                    URL.createObjectURL(event.target.files[0])
                                                                )
                                                                : setPreviewImage("");
                                                        }}
                                                    />
                                                    {previewimage ? (
                                                        <ul className="question-image-preview questions-ul">
                                                            <li className="pr_img_box">
                                                                <img
                                                                    src={previewimage}
                                                                    style={{ height: "100px" }}
                                                                    alt={"profileImg"}
                                                                />
                                                            </li>
                                                        </ul>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                                <div className="">
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("Save");
                                                        }}
                                                        className="btn btn-info mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save")}
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("");
                                                        }}
                                                        className="btn btn-success mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save_exit")}
                                                    </button>
                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        type="button"
                                                        onClick={() => navigate(-1)}
                                                    >
                                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_cancel")}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <Loader />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            ) : (
                <Loader />
            )}

        </>
    );
};

export default BannerEdit;
